import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CfgObjectDebug } from "@plansoft-configuration-renderer/debug";
/**
 * Plain wrapper around the item
 */
export function ConfigurationContainer(props) {
    return (_jsxs(_Fragment, { children: [_jsx(CfgObjectDebug, {}), props.children] }));
}
//# sourceMappingURL=ConfigurationContainer.js.map